export default __webpack_public_path__ + "static/media/CV_swedish.abfe38ec.pdf";